<template>
  <div>
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      Карточка пациента
      <router-link
        :to="{
          name: this.patients_view[user.role],
        }"
        class="text-body-1 text-sm-h6"
        >Все пациенты</router-link
      >
    </div>
    <div class="text-h6" v-if="show_company">Компания: {{ show_company }}</div>
    <v-card v-if="patient" elevation="0" class="transparent">
      <v-card class="my-5">
        <v-card-text>
          <v-card-actions class="px-0 mb-2">
            <div class="views-history text-body-1 text-sm-h5 black--text">
              Заказы
            </div>
            <v-text-field
              v-model="ordersSearch"
              flat
              solo
              class="mx-4"
              style="
                border: 1px solid #23919e;
                border-radius: 6px;
                max-width: 510px;
              "
              append-icon="mdi-magnify"
              label="Найти"
              single-line
              hide-details
              dense
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <v-btn
                v-if="
                  user.role === 'company-owner' || user.role === 'company-user'
                "
                class="white--text mr-2 custom-btn-filled"
                elevation="0"
                @click="showBuyCourseModal"
              >
                Купить курс
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  user.role === 'company-owner' || user.role === 'company-user'
                "
                class="custom-btn-outlined"
                elevation="0"
                @click="showCustomCourseModal"
              >
                Индивидуальный курс
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-tooltip
                v-if="
                  user.role === 'company-owner' || user.role === 'company-user'
                "
                bottom
                max-width="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    style="cursor: pointer; color: #23919e"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span
                  >Приобретение курса предоставляет пациенту полноценный доступ
                  ко всему комплексу нейротренинговых программ выбранного
                  направления. После оплаты пациент получает ссылку для доступа
                  ко всем сессиям курса на почту и может просматривать их в
                  личном кабинете.</span
                >
              </v-tooltip>
            </div>
          </v-card-actions>
          <v-divider class="mb-4"></v-divider>
          <object-grid
            :content_type="content_type"
            :value="filteredOrders"
            :search-bar="false"
            :show-actions="{
              edit: true,
              url: true,
              resetSessionTimer: true,
              resetViewProgress: true,
              resetCourse: true,
              delete: false,
              reset: false,
            }"
            :field-defs="[
              { text: 'Номер заказа', value: 'order_number', sortable: false },
              { text: 'Название курса', value: 'course_name' },
              { text: 'Дата заказа', value: 'order_date' },
              { text: 'Сумма', value: 'total_amount', sortable: false },
              {
                text: 'Статус курса',
                value: 'course_status_display',
                sortable: false,
              },
              {
                text: 'Текущая сессия',
                value: 'order_data[0].active_session',
                sortable: false,
              },
              { text: 'Действия', value: 'actions', sortable: false },
            ]"
            @doEditItem="showOrderSessions"
            @generateUrl="copyOrderLink"
            @doResetSessionTimer="resetOrderSessionTimer"
            @doResetViewProgress="resetOrderViewProgress"
            @doResetCourse="resetOrderCourse"
            @row-click="showOrderDetails"
            class="mb-7"
          />
        </v-card-text>
      </v-card>
      <v-card class="my-5" v-if="!userCompany || !isTrialActive">
        <v-card-text>
          <v-card-actions class="px-0 mb-2">
            <div class="views-history text-body-1 text-sm-h5 black--text">
              Сессии
            </div>
            <v-text-field
              v-model="sessionsSearch"
              flat
              solo
              class="mx-4"
              style="
                border: 1px solid #23919e;
                border-radius: 6px;
                max-width: 510px;
              "
              append-icon="mdi-magnify"
              label="Найти"
              single-line
              hide-details
              dense
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <v-btn
                v-if="
                  user.role === 'company-owner' || user.role === 'company-user'
                "
                class="white--text custom-btn-filled"
                elevation="0"
                @click="doNewVisit"
              >
                Назначить сессии
                <v-icon right small>mdi-arrow-right</v-icon>
              </v-btn>
              <v-tooltip
                v-if="
                  user.role === 'company-owner' || user.role === 'company-user'
                "
                bottom
                max-width="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    style="cursor: pointer; color: #23919e"
                  >
                    mdi-help-circle
                  </v-icon>
                </template>
                <span
                  >Назначение сессий позволяет предоставить пациенту доступ к
                  конкретным нейротренинговым сессиям. После назначения можно
                  отправить пациенту ссылку для доступа к назначенной сессии
                  либо пациент может просматривать сессии, авторизовавшись в
                  личном кабинете по логину и паролю.</span
                >
              </v-tooltip>
            </div>
            <v-btn
              v-if="user.role === 'admin' || user.role === 'manager'"
              class="white--text ml-2"
              rounded
              elevation="0"
              style="background-color: #d86568"
              @click="resetPatientTimeout"
            >
              СБРОС ТАЙМ-АУТА
            </v-btn>
          </v-card-actions>
          <v-divider class="mb-4"></v-divider>

          <v-tabs v-model="sessionsTab" class="mb-4">
            <v-tab>Назначенные сессии</v-tab>
            <v-tab>История сессий</v-tab>
          </v-tabs>

          <v-tabs-items v-model="sessionsTab">
            <v-tab-item>
              <object-grid
                :content_type="content_type"
                :value="filteredSessions"
                :search-bar="false"
                :show-actions="{
                  edit:
                    this.user.role !== 'manager' && this.user.role !== 'admin',
                  url:
                    this.user.role !== 'manager' && this.user.role !== 'admin',
                  delete:
                    this.user.role !== 'manager' && this.user.role !== 'admin',
                  refund: this.user.role !== 'manager',
                  reset:
                    this.user.role === 'admin' || this.user.role === 'manager',
                }"
                :field-defs="[
                  { text: 'Сессия', value: 'product_name' },
                  {
                    text: 'Категория',
                    value: 'category_name',
                    sortable: false,
                  },
                  {
                    text: 'Просмотрено',
                    value: 'viewProgressFormatted',
                    sortable: false,
                  },
                  { text: 'Дата назначения', value: 'date' },
                  { text: 'Назначивший', value: 'prescriber', sortable: false },
                  { text: 'Действия', value: 'actions', sortable: false },
                ]"
                @doEditItem="showSessionDialog"
                @generateUrl="generateUrl"
                @doDeleteItem="doDeleteItem"
                @doRefundItem="doRefundItem"
                @doResetWatchTime="doResetWatchTime"
                class="mb-7"
              />
            </v-tab-item>

            <v-tab-item>
              <object-grid
                :content_type="content_type"
                :value="filteredViewedSessions"
                :search-bar="false"
                :show-actions="{
                  edit: false,
                  url: false,
                  delete: false,
                }"
                :field-defs="[
                  { text: 'Сессия', value: 'product_name' },
                  {
                    text: 'Категория',
                    value: 'category_name',
                    sortable: false,
                  },
                  { text: 'Дата назначения', value: 'date' },
                  { text: 'Назначивший', value: 'prescriber', sortable: false },
                  { text: 'Статус', value: 'complete_reason', sortable: false },
                  {
                    text: 'Просмотрено',
                    value: 'viewProgressFormatted',
                    sortable: false,
                  },
                  { text: 'Дата окончания', value: 'complete_date' },
                ]"
                @doEditItem="showSessionDialog"
                @generateUrl="generateUrl"
                @doDeleteItem="doDeleteItem"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
      <v-card class="my-5">
        <v-card-subtitle>
          Последнее обновление:
          {{ new Date(patient.updatedAt).toLocaleDateString() }}
        </v-card-subtitle>
        <v-card-text>
          <property-form
            v-if="patient.id"
            :value="editableFields"
            :fields="fields"
            @input="doSave"
            :no_editing="no_editing"
          />
        </v-card-text>
      </v-card>
      <v-card class="my-5 pa-4">
        <v-row align="center" class="ma-0">
          <v-col cols="12" sm="6" class="d-flex align-center py-2">
            <span class="text-h6 mr-2"
              >Ответственный: {{ responsible_user }}</span
            >
            <v-btn
              v-if="user.role !== 'manager'"
              icon
              small
              style="background-color: #d86568"
              elevation="2"
              @click="changeResponsible = true"
            >
              <v-icon small color="white">mdi-pencil</v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="d-flex align-center justify-sm-end py-2"
          >
            <span class="text-h6 mr-2">
              Аккаунт:
              {{ patient_account?.email ? patient_account.email : "нет" }}
            </span>
            <v-btn
              v-if="
                !patient_account?.email &&
                (this.editPatientAccount ||
                  this.patient.responsible_user_id === this.user.id)
              "
              icon
              small
              style="background-color: #d86568"
              elevation="2"
              @click="doCreateAccount"
            >
              <v-icon small color="white">mdi-plus-circle</v-icon>
            </v-btn>
            <v-menu
              v-if="
                patient_account?.email &&
                (this.editPatientAccount ||
                  this.patient.responsible_user_id === this.user.id)
              "
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  style="background-color: #d86568"
                  elevation="2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small color="white">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="user.role === 'admin'"
                  @click="doChangeEmail"
                >
                  <v-list-item-title>Изменить почту</v-list-item-title>
                </v-list-item>
                <v-list-item @click="doChangePassword">
                  <v-list-item-title>Изменить пароль</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
    <v-dialog
      v-model="changeResponsible"
      :max-width="$vuetify.breakpoint.smAndUp ? '50%' : '100%'"
      ><v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
        <div class="text-right ma-3">
          <v-btn icon @click="changeResponsible = false">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-row justify="center" align="center" class="pb-5">
          <v-col cols="16" class="text-center text-h4">
            <div>Изменить ответственного</div>
          </v-col>
        </v-row>
        <v-card-text>
          <object-grid
            :value="
              users.filter(
                (user) =>
                  user.role === 'company-user' || user.role === 'company-owner'
              )
            "
            :field-defs="[
              {
                text: 'Выберите пользователя',
                value: 'full_name',
              },
            ]"
            :hide-toolbar="true"
            :selectable="true"
            :single-select="true"
            @itemSelected="(v) => (this.selected = v)"
          />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="white--text custom-btn-filled"
            @click="changeResponsibleUser()"
            :disabled="!selected"
          >
            Назначить
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
    <v-snackbar
      class="snackbar"
      v-model="snackbar"
      :timeout="timeout"
      :color="snackbarColor"
      outlined
    >
      {{ snackbarText }}
    </v-snackbar>
    <error-message-wrapper ref="error_wrapper" />

    <v-dialog v-model="showNoEmailDialog" max-width="500">
      <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
        <div class="text-right ma-3">
          <v-btn icon @click="showNoEmailDialog = false">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-row justify="center" align="center" class="px-6 pb-2">
          <v-col cols="12" class="text-center">
            <v-icon size="48" color="#d86568">mdi-account-off-outline</v-icon>
            <div class="text-h5 mt-3 font-weight-medium">
              У пациента нет учетной записи
            </div>
          </v-col>
        </v-row>
        <v-card-text class="text-center px-8 pb-2">
          Ссылка на курс будет отправлена на
          <strong>ваш email</strong>, при этом курс будет привязан к данному
          пациенту. <br /><br />
          Если вы хотите, чтобы курс был отправлен на email пациента — создайте
          ему учетную запись. После создания аккаунта окно назначения курса
          откроется автоматически.
        </v-card-text>
        <v-card-actions
          class="justify-center flex-column pb-6 px-8"
          style="gap: 12px"
        >
          <v-btn
            class="custom-btn-outlined"
            style="width: 100%"
            @click="onNoEmailCreateAccount"
          >
            <v-icon left small>mdi-account-plus</v-icon>
            Создать учетную запись
          </v-btn>
          <v-btn
            class="white--text custom-btn-filled"
            style="width: 100%"
            elevation="0"
            @click="onNoEmailContinue"
          >
            Продолжить без учётной записи
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showBuyCourseDialog"
      :max-width="$vuetify.breakpoint.smAndUp ? '70%' : '100%'"
    >
      <buy-course-modal
        v-if="showBuyCourseDialog"
        :patient="patient"
        @cancel="showBuyCourseDialog = false"
        @course-purchased="onCoursePurchased"
      />
    </v-dialog>
    <v-dialog
      v-model="showCustomCourseDialog"
      :max-width="$vuetify.breakpoint.smAndUp ? '70%' : '100%'"
    >
      <custom-course-modal
        v-if="showCustomCourseDialog"
        :patient="patient"
        @cancel="showCustomCourseDialog = false"
        @course-purchased="onCoursePurchased"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ObjectGrid from "@/components/ObjectGrid";
import PropertyForm from "@/components/PropertyForm";
import { VTextarea } from "vuetify/lib/components";
import SelectProductsForm from "@/components/SelectProductsForm";
import SessionForm from "@/components/SessionForm";
import PromptForm from "@/components/PromptForm";
import PasswordResetForm from "../components/PasswordResetForm.vue";
import EmailResetForm from "../components/EmailResetForm.vue";
import CreateAccountForm from "../components/CreateAccountForm.vue";

import ErrorMessageWrapper from "@/components/ErrorMessageWrapper.vue";
import NSApi from "@/api/NSApi";
import ApiService from "@/api/ApiService";
import MutableSessionForm from "@/components/MutableSessionForm";
import OrderSessionsModal from "@/components/OrderSessionsModal.vue";
import BuyCourseModal from "@/components/BuyCourseModal.vue";
import CustomCourseModal from "@/components/CustomCourseModal.vue";
import { COURSE_STAGES } from "@/utils/constants";

export default {
  name: "PatientView",
  components: {
    ErrorMessageWrapper,
    PropertyForm,
    ObjectGrid,
    BuyCourseModal,
    CustomCourseModal,
  },
  props: {
    patient_id: String,
    show_company: String,
    no_editing: Boolean,
  },
  data() {
    return {
      selection: 0,
      content_type: "products",
      changeResponsible: false,
      selected: undefined,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "",
      timeout: 3000,
      toggleForRefresh: false,
      haveRefundableVisits: false,
      fioRules: [(v) => !!v || "Обязательное поле"],
      emailRules: [
        (v) => !v || /.+@.+\..+/.test(v) || "Пример: abc@de.fg",
        (v) => !v || !v.includes(" ") || "Пробелы запрещены",
      ],
      passwordRules: [
        (v) =>
          !v ||
          /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/.test(v) ||
          "Минимум 8 символов, цифры, буквы, знаки",
        (v) => !v || !v.includes(" ") || "Пробелы запрещены",
      ],
      notEmptyRules: [(v) => !!v || "Обязательное поле"],

      patients_view: {
        admin: "admin-patients",
        manager: "manager-patients",
        "company-user": "company-patients",
        "company-owner": "company-patients",
        patient: "home",
      },
      patient_orders: [],
      showBuyCourseDialog: false,
      showCustomCourseDialog: false,
      showNoEmailDialog: false,
      pendingCourseModalType: null,
      ordersSearch: "",
      sessionsSearch: "",
      sessionsTab: 0,
    };
  },
  watch: {
    patient_id() {
      this.loadPatient();
      this.loadPatientOrders();
    },
    patient_account(newVal) {
      if (newVal && this.pendingCourseModalType) {
        if (this.pendingCourseModalType === "buy")
          this.showBuyCourseDialog = true;
        else if (this.pendingCourseModalType === "custom")
          this.showCustomCourseDialog = true;
        this.pendingCourseModalType = null;
      }
    },
  },
  computed: {
    ...mapGetters("patients", ["patients"]),
    ...mapGetters(["user"]),
    ...mapGetters("users", ["users"]),
    ...mapGetters("companies", ["companies"]),

    editableFields() {
      return {
        fio: this.patient?.fio,
        age: this.patient?.age,
        comment: this.patient?.comment,
        problem: this.patient?.problem,
        condition: this.patient?.condition,
        review: this.patient?.review,
      };
    },
    editPatientAccount() {
      return this.user.role === "admin" || this.user.role === "company-owner";
    },
    patient() {
      const item =
        this.patients && this.patients.find((i) => +i.id === +this.patient_id);
      const mapVisit = (v) => ({
        ...v,
        id: v.public_uuid,
        public_uuid: v.public_uuid,
        viewProgress: v.view_progress,
        viewProgressFormatted: this.formatTime(v.view_progress),
        date: v.prescribed_at,
        canRefund: v.can_refund,
        complete_date: v.complete_at,
        category_name: v.product?.Category?.name || null,
      });
      const activeMapped = (item?.visits?.active || []).map(mapVisit);
      const viewedMapped = (item?.visits?.viewed || []).map(mapVisit);
      const activeWithRefund = this.computeCanRefund(activeMapped);
      return {
        ...(item || {}),
        age: item?.age,
        comment: item?.comment,
        problem: item?.problem,
        condition: item?.condition,
        review: item?.review,
        visits: activeWithRefund,
        orders: item?.orders,
        viewed: viewedMapped,
        toggleForRefresh: this.toggleForRefresh,
      };
    },
    patient_account() {
      return this.users.find((user) => {
        return user.patient_id === this.patient?.id && user.email;
      });
    },
    responsible_user() {
      const user = this.users.find(
        (user) => user.id === this.patient.responsible_user_id
      );
      return user ? user.first_name + " " + user.last_name : "";
    },
    fields() {
      return {
        fio: {
          order: 1,
          label: "ФИО",
          visible: true,
          rules: this.notEmptyRules,
        },
        age: { order: 2, label: "Возраст", visible: true },
        problem: {
          order: 3,
          label: "Проблема или диагноз",
          component: VTextarea,
          visible: true,
        },
        comment: {
          order: 4,
          label: "Комментарий",
          component: VTextarea,
          visible: true,
        },
        condition: {
          order: 5,
          label: "Психологическое состояние",
          component: VTextarea,
          visible: true,
        },
        review: {
          order: 6,
          component: VTextarea,
          label: "Отзыв по результатам занятий",
          visible: true,
        },
      };
    },
    userCompany() {
      return this.companies.find(
        (company) => company.id === this.user.company_id
      );
    },
    isTrialActive() {
      const trialEndTime = this.userCompany?.trial_end_time;
      return trialEndTime && new Date() <= new Date(trialEndTime);
    },
    filteredOrders() {
      if (!this.ordersSearch) {
        return this.patient_orders;
      }
      const search = this.ordersSearch.toLowerCase();
      return this.patient_orders.filter((order) => {
        return (
          order.order_number?.toLowerCase().includes(search) ||
          order.course_name?.toLowerCase().includes(search) ||
          order.order_date?.toLowerCase().includes(search) ||
          order.total_amount?.toString().includes(search) ||
          order.course_status_display?.toLowerCase().includes(search)
        );
      });
    },
    filteredSessions() {
      if (!this.sessionsSearch) {
        return this.patient?.visits || [];
      }
      const search = this.sessionsSearch.toLowerCase();
      return (this.patient?.visits || []).filter((visit) => {
        return (
          visit.product_name?.toLowerCase().includes(search) ||
          visit.category_name?.toLowerCase().includes(search) ||
          visit.date?.toLowerCase().includes(search) ||
          visit.prescriber?.toLowerCase().includes(search)
        );
      });
    },
    filteredViewedSessions() {
      if (!this.sessionsSearch) {
        return this.patient?.viewed || [];
      }
      const search = this.sessionsSearch.toLowerCase();
      return (this.patient?.viewed || []).filter((session) => {
        return (
          session.product_name?.toLowerCase().includes(search) ||
          session.category_name?.toLowerCase().includes(search) ||
          session.date?.toLowerCase().includes(search) ||
          session.prescriber?.toLowerCase().includes(search) ||
          session.complete_reason?.toLowerCase().includes(search)
        );
      });
    },
    categorySessionsMap() {
      const resultMap = {};
      this.patient?.visits?.forEach((visit) => {
        // Обработка только visits у которых есть category_id и session_number
        // нужно для обратной совместимости со старыми сессиями (20.06.24)
        if (visit.category_id && visit.session_number) {
          const minimumSessionNumber = resultMap[visit.category_id] ?? Infinity;
          if (visit.session_number < minimumSessionNumber) {
            resultMap[visit.category_id] = visit.session_number;
          }
        }
      });

      return resultMap;
    },
  },
  methods: {
    ...mapActions("patients", ["request_patients", "update_patient"]),
    ...mapActions("products", ["request_products"]),
    ...mapActions("users", ["request_users", "update_user", "create_user"]),
    ...mapActions("modals", ["showModalForm"]),
    ...mapActions("companies", ["request_companies", "update_company"]),
    ...mapActions("categories", ["request_categories"]),

    formatTime(viewProgress) {
      if (viewProgress === undefined) return undefined;
      const roundedSeconds = Math.round(viewProgress);
      const minutes = Math.floor(roundedSeconds / 60);

      const remainingSeconds = roundedSeconds % 60;
      const formattedSeconds =
        remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;
      return `${minutes}:${formattedSeconds}`;
    },
    courseStatusFormatter(status) {
      const statusTranslations = {
        new: "Новый",
        in_progress: "В процессе",
        done: "Завершен",
      };
      return statusTranslations[status] || status;
    },
    // Определение возможности возврата средств за сессию.
    // prescribed_at теперь timestamptz, конвертация фронтом не нужна.
    computeCanRefund(visits) {
      const cancellationPeriod = Number(
        process.env.VUE_APP_SESSION_CANCELATION_PERIOD
      );

      return (visits || []).map((session) => {
        if (!session.date) return session;
        const sessionCreatedTime = new Date(session.date);
        if (Number.isNaN(sessionCreatedTime.getTime())) return session;
        const timeFromAppointmentMin =
          (Date.now() - sessionCreatedTime.getTime()) / (1000 * 60);
        const canRefundNew =
          !session.viewProgress && timeFromAppointmentMin < cancellationPeriod;
        if (canRefundNew && !this.haveRefundableVisits) {
          this.haveRefundableVisits = true;
        }
        return { ...session, canRefund: canRefundNew };
      });
    },
    doNewVisit() {
      this.showModalForm({
        component: SelectProductsForm,
        width: this.$vuetify.breakpoint.smAndUp
          ? "800px"
          : this.$vuetify.breakpoint.width,
        contentClass: "border-radius-30px",
      }).then(([products]) => {
        NSApi._instance
          .doPayment(
            products.map((product) => product.id),
            this.patient.id
          )
          .then(this.loadPatient)
          .catch((error) => {
            if (
              error.response?.data?.message?.includes(
                "Patient can only receive sessions from the same course category"
              )
            ) {
              this.$refs.error_wrapper.showErrorMessage(
                "Ошибка",
                "Пациент может получать сессии только из одного курса."
              );
            } else if (
              error.response?.data?.message?.includes(
                "Patient can only receive sessions of the same type"
              )
            ) {
              this.$refs.error_wrapper.showErrorMessage(
                "Ошибка",
                "Пациент может получать сессии только одного типа (PC, VR или MG)."
              );
            } else {
              this.snackbarText =
                "Произошла ошибка при проведении платежа. " +
                error.response.data.message;
              this.snackbarColor = `error`;
              this.snackbar = true;
            }
          });
      });
    },
    doSave(updatedFields) {
      const payload = {
        id: this.patient.id,
        ...updatedFields,
      };

      this.update_patient(payload).then(() => this.loadPatient());
    },

    loadPatient() {
      if (this.patient_id) {
        this.request_patients(`id=${this.patient_id}`);
      }
    },

    // ACCOUNT METHODS

    doCreateAccount() {
      this.showModalForm({
        component: CreateAccountForm,
      }).then(async (accountData) => {
        await this.request_users("all=1");

        const existingAccount = this.users.find((user) => {
          return user.patient_id === this.patient.id && user.email;
        });
        if (existingAccount) {
          await this.$refs.error_wrapper.showErrorMessage(
            "Аккаунт уже существует",
            `У данного пациента уже есть аккаунт с email: ${existingAccount.email}`
          );
          return;
        }

        const conflictUser = this.users.find((user) => {
          return user.email === accountData.email;
        });
        if (conflictUser) {
          var message = "Попробуйте выбрать другой E-Mail";
          await this.$refs.error_wrapper.showErrorMessage(
            "Данный E-Mail уже занят",
            message
          );
          return;
        }

        if (accountData.password && accountData.email) {
          await this.create_user({
            email: accountData.email,
            password: accountData.password,
            role: "patient",
            patient_id: this.patient.id,
          })
            .then(async () => {
              await this.request_users();
              this.snackbarText = `Аккаунт создан`;
              this.snackbarColor = `success`;
              this.snackbar = true;
              this.loadPatient();
            })
            .catch(async (error) => {
              await this.$refs.error_wrapper.showErrorMessage(
                "Ошибка создания аккаунта",
                error.response?.data?.error ||
                  error.message ||
                  "Неизвестная ошибка"
              );
            });
        } else {
          await this.$refs.error_wrapper.showErrorMessage(
            "Ошибка создания аккаунта",
            "Некорректно введены поля."
          );
        }
      });
    },
    async doSaveAccount(item) {
      await this.request_users("all=1");

      const conflictUser = this.users.find((user) => {
        return user.email === item.email;
      });
      if (conflictUser) {
        var message = "Попробуйте выбрать другой E-Mail";
        await this.$refs.error_wrapper.showErrorMessage(
          "Данный E-Mail уже занят",
          message
        );
        return;
      }

      if (this.patient_account) {
        await this.update_user({
          ...this.patient_account,
          email: item.email,
          password: item.password,
        }).then(() => this.loadPatient());
        return;
      }
      if (item.password && item.email)
        await this.create_user({
          email: item.email,
          password: item.password,
          role: "patient",
          patient_id: this.patient.id,
        });
      else
        await this.$refs.error_wrapper.showErrorMessage(
          "Ошибка создания аккаунта",
          "Некорректно введены поля."
        );
    },
    //

    showSessionDialog(item) {
      // Проверка только visits у которых есть category_id и session_number
      // нужно для обратной совместимости с старыми сессиями (20.06.24)
      if (
        item.session_number &&
        item.session_number > this.categorySessionsMap[item.category_id]
      ) {
        this.$refs.error_wrapper.showErrorMessage(
          "Ошибка",
          "Для просмотра данной сессии необходимо сначала ознакомиться с предыдущими. Ваша текущая сессия имеет номер " +
            this.categorySessionsMap[item.category_id]
        );
      } else {
        this.showModalForm({
          title: item.product_name,
          component: SessionForm,
          width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
          item,
          patient_id: this.patient_id,
          saveMethod: (item) => {
            const patch = {};
            if (item.viewProgress !== undefined)
              patch.view_progress = item.viewProgress;
            if (item.product_name !== undefined)
              patch.product_name = item.product_name;
            return ApiService.patch(
              `/api/patient-visits/${item.public_uuid}`,
              patch
            ).then(() => this.loadPatient());
          },
          archiveItem: () => {
            item.complete_reason = "Просмотрено";
            this.archiveItem(item);
          },
        }).then((payload) => {
          console.log(payload);
        });
      }
    },
    archiveItem(item) {
      return ApiService.patch(`/api/patient-visits/${item.public_uuid}`, {
        status: "viewed",
        complete_reason: item.complete_reason || "Просмотрено",
      }).then(() => this.loadPatient());
    },
    doDeleteItem(item) {
      this.showModalForm({
        component: PromptForm,
        title: `Вы уверены что хотите удалить ${item.product_name}?`,
        desc: `Подтвердите действие`,
        value: item,
      }).then(() => {
        item.complete_reason = "Удалено";
        this.archiveItem(item);
        this.loadPatient();
      });
    },
    resetPatientTimeout() {
      this.update_patient({
        ...this.patient,
        timeout: null,
      });

      this.snackbarText = `Тайм-аут на просмотр сессий пациента сброшен`;
      this.snackbarColor = `info`;
      this.snackbar = true;
    },
    doResetWatchTime(item) {
      return ApiService.patch(`/api/patient-visits/${item.public_uuid}`, {
        view_progress: 0,
      }).then(() => this.loadPatient());
    },
    changeResponsibleUser() {
      this.update_patient({
        id: this.patient.id,
        responsible_user_id: this.selected[0].id,
      }).then(() => this.loadPatient());

      this.changeResponsible = false;
      this.snackbarText = `Ответственный изменен на ${this.responsible_user}`;
      this.snackbarColor = `info`;
      this.snackbar = true;
    },
    generateUrl(item) {
      const visitUuid = item.public_uuid;

      if (!visitUuid) {
        this.snackbarText = `Не удалось сформировать ссылку: данные ещё не загружены`;
        this.snackbarColor = `error`;
        this.snackbar = true;
        return;
      }

      navigator.clipboard.writeText(
        `${process.env.VUE_APP_BASE_PATH}/session-by-url/${visitUuid}`
      );

      this.snackbarText = `Ссылка скопирована в буфер обмена`;
      this.snackbarColor = `info`;
      this.snackbar = true;
    },

    doRefundItem(item) {
      this.showModalForm({
        component: PromptForm,
        title: `Вы уверены что хотите отменить назначение ${item.product_name}?`,
        desc: `Подтвердите действие`,
        value: item,
      }).then(() => {
        NSApi._instance
          .doRefund(item.id, this.patient.id)
          .then(this.loadPatient);
      });
    },
    doChangePassword() {
      this.showModalForm({
        component: PasswordResetForm,
      }).then((newPassword) => {
        this.update_user({
          ...this.patient_account,
          password: newPassword,
        }).then(async () => {
          await this.request_users();
          this.snackbarText = `Пароль изменен`;
          this.snackbarColor = `success`;
          this.snackbar = true;
          this.loadPatient();
        });
      });
    },
    doChangeEmail() {
      this.showModalForm({
        component: EmailResetForm,
      }).then((newEmail) => {
        this.update_user({
          ...this.patient_account,
          email: newEmail,
        }).then(async () => {
          await this.request_users();
          this.snackbarText = `Email изменен`;
          this.snackbarColor = `success`;
          this.snackbar = true;
          this.loadPatient();
        });
      });
    },

    // ORDER METHODS
    async loadPatientOrders() {
      try {
        const response = await ApiService.get(
          `v1/patients/${this.patient_id}/orders`
        );
        const orders = response.data || [];

        this.patient_orders = orders.map((order) => ({
          ...order,
          course_name:
            order.custom_course_name ||
            order.order_data?.[0].course_name +
              (order.stage ? ` [ ${COURSE_STAGES[order.stage]} ]` : ""),
          course_status_display: this.courseStatusFormatter(
            order.order_data?.[0]?.course_status
          ),
        }));
      } catch (error) {
        console.error("Ошибка загрузки заказов пациента:", error);
        this.patient_orders = [];
      }
    },
    formatAssignedBy(user) {
      if (!user) return "—";
      const fullName = [user.first_name, user.last_name]
        .filter(Boolean)
        .join(" ")
        .trim();
      if (fullName) return fullName;
      return user.email || `User #${user.id}`;
    },
    copyOrderLink(order) {
      const link = order.order_data?.[0]?.link;
      if (!link) {
        this.snackbarText =
          "Ссылка не скопирована! Заказ не оплачен или не активен.";
        this.snackbarColor = "error";
        this.snackbar = true;
        return;
      }

      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.snackbarText = "Ссылка успешно скопирована!";
          this.snackbarColor = "success";
          this.snackbar = true;
        })
        .catch((err) => {
          this.snackbarText = "Ошибка копирования ссылки!";
          this.snackbarColor = "error";
          this.snackbar = true;
          console.error(err);
        });
    },
    async showOrderSessions(order) {
      try {
        const orderResponse = await ApiService.get(
          `v1/orders/${order.order_number}`
        );
        const orderData = orderResponse.data;

        if (
          orderData &&
          orderData.order_data &&
          orderData.order_data.length > 0
        ) {
          const orderDataItem = orderData.order_data[0];

          const videoOrderResponse = await ApiService.get(
            `v1/videoOrder/${orderDataItem.id}`
          );
          const fullOrderData = videoOrderResponse.data;

          if (
            fullOrderData &&
            fullOrderData.user_products &&
            fullOrderData.user_products.length > 0
          ) {
            const firstProduct = fullOrderData.user_products[0];
            const videos = firstProduct.videos || [];

            if (videos.length > 0) {
              let activeVideo = videos.find(
                (video) =>
                  video.status === "new" || video.status === "in_progress"
              );

              if (!activeVideo) {
                activeVideo = videos[0];
              }

              const kinescopeId = activeVideo.kinescope_id;

              this.showModalForm({
                title: `Сессия заказа ${order.order_number}`,
                component: MutableSessionForm,
                width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
                item: {
                  id: orderDataItem.id,
                  name:
                    activeVideo.name || `Сессия заказа ${order.order_number}`,
                  kinescope_id: kinescopeId,
                  order_number: order.order_number,
                  order_data_id: orderDataItem.id,
                  video_id: activeVideo.id,
                  viewProgress: activeVideo.view_progress || 0,
                  playback_availability_time:
                    activeVideo.playback_availability_time,
                },
                patient_id: this.patient_id,
                // Результат возвращаем в MutableSessionForm: бэк отвечает 409,
                // когда сессия недоступна (см. sessionAccess на бэкенде), и
                // плеер обязан это показать. try/catch здесь не нужен —
                // ApiService не бросает, а возвращает { success: false }.
                onVideoEnded: async ({ viewPercent }) => {
                  const params = {
                    orderDataId: orderDataItem.id,
                    itemId: activeVideo.id,
                  };
                  if (viewPercent !== undefined) {
                    params.viewPercent = viewPercent;
                  }
                  return ApiService.get(`v1/videoOrder/view-end`, params);
                },
                onUpdateViewProgress: async ({ watchtime, viewPercent }) => {
                  const params = {
                    orderDataId: orderDataItem.id,
                    itemId: activeVideo.id,
                    watchtime,
                  };
                  if (viewPercent !== undefined) {
                    params.viewPercent = viewPercent;
                  }
                  return ApiService.get(`v1/videoOrder/watchtime`, params);
                },
                onDestroy: () => {
                  this.loadPatientOrders();
                },
              });
            } else {
              this.snackbarText = "В заказе нет доступных сессий";
              this.snackbarColor = "warning";
              this.snackbar = true;
            }
          } else {
            this.snackbarText = "В заказе нет продуктов";
            this.snackbarColor = "warning";
            this.snackbar = true;
          }
        } else {
          this.snackbarText = "Данные заказа не найдены";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Ошибка загрузки сессий заказа:", error);
        this.snackbarText = "Ошибка загрузки сессий заказа";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    async showOrderDetails(order) {
      try {
        const orderResponse = await ApiService.get(
          `v1/orders/${order.order_number}`
        );
        const orderData = orderResponse.data;

        if (
          orderData &&
          orderData.order_data &&
          orderData.order_data.length > 0
        ) {
          const orderDataItem = orderData.order_data[0];

          const videoOrderResponse = await ApiService.get(
            `v1/videoOrder/${orderDataItem.id}`
          );
          const fullOrderData = videoOrderResponse.data;

          if (
            fullOrderData &&
            fullOrderData.user_products &&
            fullOrderData.user_products.length > 0
          ) {
            const firstProduct = fullOrderData.user_products[0];
            const videos = firstProduct.videos || [];

            if (videos.length > 0) {
              this.showModalForm({
                component: OrderSessionsModal,
                width: this.$vuetify.breakpoint.smAndUp ? "70%" : "90%",
                orderNumber: order.order_number,
                orderDataId: orderDataItem.id,
                // Специалист смотрит курс только на чтение — статусы сессий
                // меняются из раздела B2C-курсов.
                readOnlyStatus: true,
                // Та же шапка, что и в списке B2C-курсов: реальное название,
                // этап, даты, ответственный.
                courseMeta: {
                  name: order.custom_course_name || firstProduct.name || "Курс",
                  originalProductName: orderDataItem.course_name || null,
                  stage: order.stage,
                  status: firstProduct.status,
                  createdAt: order.created_at || order.order_date,
                  endDate: firstProduct.end_date,
                  lastWatch: firstProduct.last_watch_time_update,
                  assignedBy: order.assignedBy
                    ? this.formatAssignedBy(order.assignedBy)
                    : null,
                  patient: this.patient?.fio || null,
                },
                sessions: videos.map((video) => ({
                  ...video,
                  playback_availability_time: video.playback_availability_time
                    ? new Date(video.playback_availability_time)
                    : null,
                  viewed_at: video.viewed_at ? new Date(video.viewed_at) : null,
                })),
              }).then(() => {
                this.loadPatientOrders();
              });
            } else {
              this.snackbarText = "В заказе нет доступных сессий";
              this.snackbarColor = "warning";
              this.snackbar = true;
            }
          } else {
            this.snackbarText = "В заказе нет продуктов";
            this.snackbarColor = "warning";
            this.snackbar = true;
          }
        } else {
          this.snackbarText = "Данные заказа не найдены";
          this.snackbarColor = "error";
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Ошибка загрузки сессий заказа:", error);
        this.snackbarText = "Ошибка загрузки сессий заказа";
        this.snackbarColor = "error";
        this.snackbar = true;
      }
    },
    async resetOrderSessionTimer(order) {
      try {
        await ApiService.post(
          `v1/orders/${order.order_number}/reset_session_timer`
        );
        this.snackbarText = "Таймаут сессии успешно сброшен!";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.loadPatientOrders();
      } catch (err) {
        this.snackbarText =
          "Ошибка сброса таймаута сессии! Обратитесь к администратору.";
        this.snackbarColor = "error";
        this.snackbar = true;
        console.error(err);
      }
    },
    async resetOrderViewProgress(order) {
      try {
        await ApiService.post(
          `v1/orders/${order.order_number}/reset_view_progress`
        );
        this.snackbarText = "Прогресс просмотра успешно сброшен!";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.loadPatientOrders();
      } catch (err) {
        this.snackbarText =
          "Ошибка сброса прогресса просмотра! Обратитесь к администратору.";
        this.snackbarColor = "error";
        this.snackbar = true;
        console.error(err);
      }
    },
    async resetOrderCourse(order) {
      try {
        await ApiService.post(`v1/orders/${order.order_number}/reset_course`);
        this.snackbarText = "Курс полностью сброшен в начальное состояние!";
        this.snackbarColor = "success";
        this.snackbar = true;
        this.loadPatientOrders();
      } catch (err) {
        this.snackbarText =
          "Ошибка полного сброса курса! Обратитесь к администратору.";
        this.snackbarColor = "error";
        this.snackbar = true;
        console.error(err);
      }
    },
    showOrderSessionDialog(item) {
      this.showModalForm({
        title: item.name,
        component: MutableSessionForm,
        width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
        item: item,
        patient_id: this.patient_id,
        // Можно переопределить video_data/session_id при необходимости:
        // video_data: item.kinescope_id,
        // session_id: `${item.id}${this.patient_id}`,
        // Как и выше: отказ бэка отдаём плееру, а не в консоль.
        onVideoEnded: async ({ viewPercent }) => {
          const params = {
            orderDataId: item.order_data_id,
            itemId: item.video_id,
          };
          if (viewPercent !== undefined) {
            params.viewPercent = viewPercent;
          }
          return ApiService.get(`v1/videoOrder/view-end`, params);
        },
        onUpdateViewProgress: async ({ item, watchtime, viewPercent }) => {
          const params = {
            orderDataId: item.order_data_id,
            itemId: item.video_id,
            watchtime,
          };
          if (viewPercent !== undefined) {
            params.viewPercent = viewPercent;
          }
          return ApiService.get(`v1/videoOrder/watchtime`, params);
        },
        onDestroy: () => {
          this.loadPatient();
        },
        archiveItem: () => {
          item.status = "done";
        },
      });
    },
    showBuyCourseModal() {
      if (!this.patient_account) {
        this.pendingCourseModalType = "buy";
        this.showNoEmailDialog = true;
      } else {
        this.showBuyCourseDialog = true;
      }
    },
    showCustomCourseModal() {
      if (!this.patient_account) {
        this.pendingCourseModalType = "custom";
        this.showNoEmailDialog = true;
      } else {
        this.showCustomCourseDialog = true;
      }
    },
    onNoEmailContinue() {
      this.showNoEmailDialog = false;
      if (this.pendingCourseModalType === "buy")
        this.showBuyCourseDialog = true;
      else if (this.pendingCourseModalType === "custom")
        this.showCustomCourseDialog = true;
      this.pendingCourseModalType = null;
    },
    onNoEmailCreateAccount() {
      this.showNoEmailDialog = false;
      this.doCreateAccount();
    },
    onCoursePurchased() {
      this.loadPatient();
      this.loadPatientOrders();
      this.snackbarText = "Курс успешно приобретен!";
      this.snackbarColor = "success";
      this.snackbar = true;
    },
  },
  async beforeMount() {
    this.request_users();
    this.request_categories();
    this.request_companies();

    this.loadPatient();
    this.loadPatientOrders();

    this.updateRefundPropInterval = setInterval(() => {
      this.toggleForRefresh = !this.toggleForRefresh;

      if (this.haveRefundableVisits) {
        this.loadPatient();
        this.haveRefundableVisits = false;
      }
    }, 10000);
  },
  mounted() {
    // load products for SelectProductsForm
    this.request_products("sort=category_id");
  },
  beforeDestroy() {
    clearInterval(this.updateRefundPropInterval);
  },
};
</script>

<style scoped lang="scss">
.toolbar-content {
  background-color: #f0f8f6;
  color: #d86568 !important;
}

.custom-btn-filled {
  background-color: #d86568 !important;
  border-radius: 24px !important;
  height: 48px !important;
  padding: 0 24px !important;
  text-transform: none !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: normal !important;
}

.custom-btn-outlined {
  background-color: white !important;
  border: 2px solid #d86568 !important;
  color: #d86568 !important;
  border-radius: 24px !important;
  height: 48px !important;
  padding: 0 24px !important;
  text-transform: none !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  letter-spacing: normal !important;
}

.custom-btn-filled:hover {
  background-color: #c75558 !important;
}

.custom-btn-outlined:hover {
  background-color: #fef5f5 !important;
}

::v-deep .v-tabs {
  .v-tab {
    text-transform: none;
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    letter-spacing: normal;
  }

  .v-tab--active {
    color: #23919e;
    font-weight: 500;
  }

  .v-tabs-slider {
    background-color: #23919e;
    height: 3px;
  }
}

::v-deep .v-data-table {
  thead th {
    vertical-align: middle !important;

    .v-data-table-header__icon {
      margin-left: 4px;
      vertical-align: middle;
    }
  }
}

@import "~vuetify/src/styles/styles.sass";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .views-history {
    max-width: 100px;
  }
}
</style>
